import React, { useEffect, useState } from "react";
import axiosInstance from "../axios/axios";
import editIcon from "../assets/editIcon.svg";
import Loader from "./Loader";
import SuccessMessage from "./SuccessMessage";

const CompanyProfile = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false); // Track edit mode
  const [updatedUser, setUpdatedUser] = useState({});
  const [locations, setLocations] = useState([]);

  const userId = localStorage.getItem("user_id");
  const orgId = localStorage.getItem("role_specific_id");

  const fetchUserById = async () => {
    try {
      const response = await axiosInstance.get("all_users");
      const foundUser = response.data.users.find(
        (u) => u.user_id === parseInt(userId)
      );
      if (foundUser) {
        setUser(foundUser);
        console.log(foundUser);
        setUpdatedUser(foundUser.organization);
        setError({});
      } else {
        setError({ general: "User not found" });
      }
    } catch (error) {
      setError({ general: "Failed to fetch user data" });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await axiosInstance.get("locations");
      setLocations(response.data.data.map((state) => state.name));
    } catch {
      console.log("Error fetching locations");
    }
  };

  useEffect(() => {
    fetchLocations();

    fetchUserById();
  }, []);

  if (loading) return <Loader />;
  if (error.general) return <p>{error.general}</p>;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};
    // Add validation for required fields
    const requiredFields = [
      "company_name",
      "company_state",
      "company_street_address",
      "phone",
    ];
    requiredFields.forEach((field) => {
      if (!updatedUser[field]) {
        errors[field] = `${field.replace("_", " ")} is required.`;
      }
    });
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      // Assuming you update the organization data
      const response = await axiosInstance.put(
        `organization/${orgId}/update`,
        updatedUser
      );
      console.log();
      // Handle success response
      setUser((prev) => ({
        ...prev,
        organization: updatedUser,
      }));
      setSuccess("Profile Edited Successfully");
      setEditMode(false); // Exit edit mode
      setError({}); // Clear errors

      console.log(response); // Log success response
    } catch (error) {
      console.error(error);
      setError({ general: "Failed to update company profile" });
    }
  };

  return (
    <div>
      <div className="flex flex-col justify-between items-center w-full top-bar"></div>
      {success && <SuccessMessage message={success} />}
      <section className="md:mt-[20px] flex px-[36px] py-6 flex-col gap-6 max-w-[592px]">
        {editMode ? (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            {success && <SuccessMessage message={success} />}
            <div className="flex flex-col gap-4">
              <label className="label-name w-full">Company Name</label>
              <input
                type="text"
                name="company_name"
                value={updatedUser.company_name || ""}
                onChange={handleChange}
                className="custom-form"
              />
            </div>
            {/* <div className="flex flex-col gap-4">
              <label className="label-name w-full">Company State</label>
              <input
                type="text"
                name="company_state"
                value={updatedUser.company_state || ""}
                onChange={handleChange}
                className="custom-form"
              />
            </div> */}
            <div className="flex flex-col gap-4">
              <label className="label-name w-full">Company State</label>
              <select
                required
                name="company_state"
                id="state"
                className="custom-form"
                value={updatedUser.company_state || ""}
                onChange={handleChange}
              >
                <option value="">-- Select your State --</option>
                {locations.map((location, index) => (
                  <option key={index} value={location}>
                    {location}
                  </option>
                ))}
              </select>
              {/* <input
                type="text"
                name="company_state"
                value={updatedUser.company_state || ""}
                onChange={handleChange}
                className="custom-form"
              /> */}
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name w-full">
                Company Street Address
              </label>
              <input
                type="text"
                name="company_address"
                value={updatedUser.company_street_address || ""}
                onChange={handleChange}
                className="custom-form"
              />
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name w-full">Company Phone</label>
              <input
                type="number"
                name="phone"
                value={updatedUser.phone || ""}
                onChange={handleChange}
                className="custom-form"
              />
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name w-full">Company CAC Number</label>
              <input
                type="number"
                name="company_cac_number"
                value={updatedUser.company_cac_number || ""}
                onChange={handleChange}
                className="custom-form"
              />
            </div>
            <button type="submit" className="btn-success btn">
              Save Changes
            </button>
            <button
              type="button"
              className="btn-danger btn mt-2"
              onClick={() => setEditMode(false)}
            >
              Cancel
            </button>
          </form>
        ) : (
          <>
            <div className="flex flex-col gap-4">
              <span className="label-name w-full">Name</span>
              <span className="content-container">
                {user?.organization.company_name || "N/A"}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name">Email</span>
              <span className="content-container">{user?.email || "N/A"}</span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name w-full">Address</span>
              <span className="content-container">
                {user?.organization.company_street_address || "N/A"}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name w-full">Location</span>
              <span className="content-container">
                {user?.organization.company_state || "N/A"}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name w-full">CAC</span>
              <span className="content-container">
                {user?.organization.company_cac_number || "N/A"}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name w-full">Phone</span>
              <span className="content-container">
                {user?.organization.phone || "N/A"}
              </span>
            </div>
            <button
              onClick={() => setEditMode(true)}
              className="flex gap-2 btn-success btn items-center justify-center my-3"
            >
              <img src={editIcon} alt="Edit Icon" />
              <span>Edit</span>
            </button>
          </>
        )}
      </section>
    </div>
  );
};

export default CompanyProfile;
